export default __webpack_public_path__ + "static/media/IMG-20210701-WA00631.c37ab6df.png";